export default __webpack_public_path__ + "static/figure_man-6b4a330b6c42949e5996127a0610e7c8.png";